import * as React from "react"
import { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"

import IconArrowRight from "./icons/IconArrowRight"
import IconMapMarker from "./icons/IconMapMarker"
import IconPhone from "./icons/IconPhone"
import IconEnvelope from "./icons/IconEnvelope"
import IconFacebook from "./icons/IconFacebook"
import IconYouTube from "./icons/IconYouTube"
import IconInstagram from "./icons/IconInstagram"
import IconCallMeBackNew from "./icons/IconCallMeBackNew"
import IconAppointment from "./icons/IconAppointment"
import IconAssistant from "./icons/IconAssistant"
import IconCheckGreen from "./icons/IconCheckGreen"

import BackToTop from "./BackToTop"
import FooterNav from "./FooterNav"
import FormCallMeBack from "./FormCallMeBack"


export default function Footer({ error, loading, success, contact = true, title = 'Kontakt', bgClass = 'bg-rekord-lgray', landing = false }) {

    const [sectionMainTitle, setSectionMainTitle] = useState(title)
    const [allLocations, setAllLocations] = useState([])
    const [calendlyUrl, setCalendlyUrl] = useState('')
    const [zipCode, setZipCode] = useState('')
    const [locationEmail, setLocationEmail] = useState('')
    const [locationName, setLocationName] = useState('')

    var structuredData = {
        '@context': 'https://schema.org/',
        '@type': 'Organization',
        'name': 'REKORD Fenster',
        'url': 'https://rekord-fenster.com',
        'logo': 'https://rekord-fenster.b-cdn.net/wp-content/uploads/2023/03/REKORD_Logo_neuerClaim2021_png.webp'
    }
    var websiteStructuredData = {
        '@context': 'https://schema.org/',
        '@type': 'WebSite',
        'name': 'REKORD Fenster',
        'url': 'https://rekord-fenster.com'
    }

    function contactKeyPressed(e) {
        if (e.charCode === 13) {
            getSellerContacts(zipCode, false, contactType)
        }
    }

    function getSellerContacts(zip, automatic = false, type = false) {

        //console.log(zip)
        //console.log(automatic)
        //console.log(type)

        setSectionMainTitle(title)

        if (automatic === 'assigned') {
            if (type === 'booking') {
                window.open(calendlyUrl, '_blank')
                setResponseExpanded(true)
            }
            if (type === 'call_me_back') {
                setCallMeBackExpanded(true)
            }
            if (type === 'contacts') {
                setPartnerExpanded(true)
            }
            setContactType('')
            return
        }

        var plz = parseInt(zip)
        var plzString = zip.toString()
        var errorWrapper = document.getElementById('contactError')

        errorWrapper.innerHTML = ''

        if (Number.isInteger(plz)) {

            if (plzString.length < 4) {

                errorWrapper.innerHTML = 'PLZ ist zu kurz'
                if (!automatic) {
                    document.getElementById('contactStart').classList.remove("hidden")
                    document.getElementById('contactSuccess').classList.add("hidden")
                }

            } else if (plzString.length >= 4) {

                if (!automatic) {
                    document.getElementById('contactStart').classList.add("hidden")
                    document.getElementById('contactSuccess').classList.remove("hidden")
                }

                window.fetch("https://api.rekord-fenster.com/main/getadviser/" + plz)
                    .then(response => response.json())
                    .then(
                        response => {

                            if (response.success === true) {

                                document.getElementById('allLocationsDropdown').querySelector('select').value = response.data.locationId
                                document.getElementById('_location_id').value = response.data.locationId
                                setLocationEmail(response.data.location_mail)
                                setCalendlyUrl(response.data.calendly)

                                var phoneHref = response.data.tel.replace(/^0+/, '+43')
                                var phoneVisible = response.data.tel
                                var email = response.data.username

                                document.getElementById('contactResponseError').classList.add("hidden")
                                document.getElementById('rekordName').innerHTML = response.data.main_location
                                document.getElementById('rekordAddress').innerHTML = '<div class="text-black">' + response.data.address + ', ' + response.data.zip + ' ' + response.data.location + '<br /><a href="' + response.data.maps + '" target="_blank" rel="noreferrer" class="inline-flex items-center text-rekord-orange font-bold no-underline">Route planen <svg width="40" height="40" viewBox="0 0 66 58" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" className="inline-block undefined"><defs><filter x="-71.9%" y="-95.8%" width="243.8%" height="291.7%" filterUnits="objectBoundingBox" id="filter-ywffxgcyxm-1"><feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur><feColorMatrix values="0 0 0 0 1   0 0 0 0 0.518   0 0 0 0 0  0 0 0 0.25 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="DKT-System/Button/Text-Link-zweizeilig" transform="translate(-4.000000, -17.000000)"><g id="Pfeil" filter="url(#filter-ywffxgcyxm-1)" transform="translate(21.000000, 34.000000)"><line x1="-1.20036702e-13" y1="12" x2="29.0253555" y2="11.9986061" id="Stroke-10" stroke="#FF8400" stroke-width="3"></line><polygon id="Fill-12" fill="#FF8400" points="18.9616519 24 16.9390478 21.8505273 27.6472136 12.001834 16.9390478 2.14947272 18.9616519 0 32 12.001834"></polygon></g></g></g></svg></a></div>'
                                document.getElementById('contactPhoneNumber').innerHTML = '<a class="font-light" href="tel:' + phoneHref + '" title="Jetzt Rekord Fenster anrufen!">' + phoneVisible + '</a>'
                                document.getElementById('contactMail').innerHTML = '<a class="font-light" href="mailto:' + email + '" title="Jetzt Rekord Fenster per Email kontaktiere!">' + email + '</a>'
                                document.getElementById('contactName').innerHTML = response.data.salutation + ' ' + response.data.firstName + ' ' + response.data.lastName
                                document.getElementById('contactImage').innerHTML = '<img class="w-24 h-24 rounded-full object-cover m-0" src="' + response.data.img + '" alt="' + response.data.firstName + ' ' + response.data.lastName + '" />'

                                setLocationName(response.data.main_location)

                                if (type === 'booking') {
                                    window.open(response.data.calendly, '_blank')
                                    setResponseExpanded(true)
                                }
                                if (type === false) {
                                    setResponseExpanded(true)
                                }
                                if (type === 'call_me_back') {
                                    setCallMeBackExpanded(true)
                                }
                                if (type === 'contacts') {
                                    setPartnerExpanded(true)
                                }
                                setZipFormExpanded(false)
                                setContactType('')

                            } else {

                                document.getElementById('contactResponseError').classList.remove("hidden")
                                setResponseExpanded(false)
                                setContactType('')

                            }

                        },
                        errorData => {
                            console.log('ERROR')
                        }
                    )

            }

        } else {

            if (plzString.length === 0) {
                errorWrapper.innerHTML = 'PLZ ist zu kurz'
            } else {
                errorWrapper.innerHTML = 'PLZ muss numerisch sein!'
            }

        }

        // console.log(plz)
        // console.log(plzString.length)
        // console.log(plz.toString().length)
        // console.log(Number.isInteger(plz))

    }

    function selectedLocation(zip, type = false) {

        return getSellerContacts(zip, true, type)

    }

    const data = useStaticQuery(graphql`
           query {
               wp {
                   rekord {
                       footerNewSettings {
                          footerNewText
                          footerNewTitleStep2Col1
                          footerNewTitleStep2Col2
                          footerNewTitleStep2Col3
                          footerNewTextStep2Col1
                          footerNewTextStep2Col2
                          footerNewTextStep2Col3
                          footerNewTextForm
                       }
                   }
               }
           }
       `)

    useEffect(() => {
        fetch(`https://api.rekord-fenster.com/main/getallmainlocations?detail=true`)
            .then(response => response.json())
            .then(resultData => {
                setAllLocations(resultData.data)
            })
    }, [])

    const settings = data.wp.rekord.footerNewSettings

    const [isCallMeBackExpanded, setCallMeBackExpanded] = useState(false)
    const [isLocationsSelectorExpanded, setLocationsSelectorExpanded] = useState(false)
    const [isPartnerExpanded, setPartnerExpanded] = useState(false)
    const [isResponseExpanded, setResponseExpanded] = useState(true)
    const [isZipFormExpanded, setZipFormExpanded] = useState(false)
    const [contactType, setContactType] = useState('')
    const contacts = React.createRef()

    return (
        <>
            {contact === true ?
                <section ref={contacts} className={bgClass + ' footer-contact'} id="contact">
                    <div className="container mx-auto py-24">
                        <h3 className="uppercase font-bold text-3xl lg:text-5xl text-center"><span dangerouslySetInnerHTML={{ __html: sectionMainTitle }} /></h3>
                        <div className={isZipFormExpanded ? 'translate-x-0 transition-transform duration-300 max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 justify-center' : 'translate-x-full transition-transform duration-300 opacity-0 overflow-hidden max-h-0'}>
                            <div className="md:col-span-2">
                                <p className="text-base text-center md:text-left mt-8">{settings.footerNewText}</p>
                            </div>
                            <div className="form-group mt-0 mb-6">
                                <p className="mb-2 text-sm text-center md:text-left">Bitte gib deine PLZ ein</p>
                                <label htmlFor="contactPostCode" className="sr-only">PLZ</label>
                                <input
                                    id="contactPostCode"
                                    maxLength={6}
                                    type="number"
                                    placeholder="z.B.: 9500"
                                    value={zipCode}
                                    onChange={(e) => { setZipCode(e.target.value) }}
                                    onKeyPress={contactKeyPressed}
                                />
                                <button onClick={() => { getSellerContacts(zipCode, false, contactType) }} >
                                    <span id="contactSuccess" className="hidden"><IconCheckGreen w="48" h="60" /></span>
                                    <span id="contactStart"><IconArrowRight w="48" h="60" /></span>
                                </button>
                                <div id="contactError" className="text-red-500 text-xs"></div>
                                <div id="contactResponseError" className="hidden text-red-500 mt-6">Es konnte kein Berater zu deiner PLZ gefunden werden, bitte wähle einen Standort aus</div>
                            </div>
                            <div id="allLocationsDropdown">
                                <p className="mb-2 text-sm text-center md:text-left">oder wähle <button className="text-rekord-dorange font-semibold uppercase" type="button" onClick={() => { setLocationsSelectorExpanded(true) }}>hier</button> einen (anderen) Standort:</p>
                                <select
                                    className={isLocationsSelectorExpanded ? 'dropdown-options dropdown-locations opacity-100 overflow-visible max-h-infinite transition-opacity duration-300' : 'opacity-0 overflow-hidden max-h-0'}
                                    onChange={(e) => {
                                        selectedLocation(e.target.options[e.target.options.selectedIndex].dataset.zip, contactType)
                                        setZipCode(e.target.options[e.target.options.selectedIndex].dataset.zip)
                                        setCallMeBackExpanded(false)
                                        setPartnerExpanded(false)
                                        setSectionMainTitle(title)
                                    }}
                                >
                                    <option>- Standort auswählen -</option>
                                    {allLocations.map((loc, i) => (
                                        <option key={i} className="dropdown-option" data-zip={loc.zip} value={loc.id}>{loc.location_name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="md:col-span-2">
                                <button
                                    className="text-sm mt-8 flex items-center mx-auto opacity-40 hover:opacity-100 transition-opacity duration-300"
                                    onClick={() => {
                                        setContactType('');
                                        setZipFormExpanded(false);
                                        setSectionMainTitle('Kontakt');
                                        setResponseExpanded(true)
                                    }}
                                >
                                    <span class="text-black font-bold">&lt;</span>&nbsp;<span>Zurück</span>
                                </button>
                            </div>
                        </div>
                        <div className={isCallMeBackExpanded ? 'translate-x-0 transition-transform duration-300 max-w-3xl mx-auto' : 'translate-x-full transition-transform duration-300 opacity-0 overflow-hidden max-h-0'}>
                            <div>
                                <h4 className="mb-6 mt-12">Rückruf</h4>
                                <p className="text-base">{settings.footerNewTextForm}</p>
                            </div>
                            <FormCallMeBack formId="callMeBack" zipCode={zipCode} locationEmail={locationEmail} />
                            <div className="md:col-span-2">
                                <button
                                    className="text-sm mt-8 flex items-center mx-auto opacity-40 hover:opacity-100 transition-opacity duration-300"
                                    onClick={() => {
                                        setContactType('');
                                        setCallMeBackExpanded(false);
                                        setResponseExpanded(true)
                                    }}
                                >
                                    <span class="text-black font-bold">&lt;</span>&nbsp;<span>Zurück</span>
                                </button>
                                {zipCode !== '' && locationName !== '' &&
                                    <div className='pt-8 text-center'>
                                        <span className="text-sm">Dein Standort:<br /><strong>{locationName}</strong></span>
                                        <button
                                            className="mt-4 text-sm flex items-center mx-auto opacity-100 hover:opacity-40 transition-opacity duration-300"
                                            onClick={() => {
                                                setPartnerExpanded(false);
                                                setResponseExpanded(false);
                                                setCallMeBackExpanded(false);
                                                setSectionMainTitle(title);
                                                setContactType('call_me_back')
                                                setLocationsSelectorExpanded(true);
                                                setZipFormExpanded(true)
                                            }}
                                        >
                                            Möchtest du einen<span class="font-bold text-rekord-orange">&nbsp;anderen Standort&nbsp;</span>auswählen?
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className={isPartnerExpanded ? 'translate-x-0 transition-transform duration-300 flex justify-center my-6' : 'translate-x-full transition-transform duration-300 opacity-0 overflow-hidden max-h-0'}>
                            <div className="w-full flex flex-col items-center lg:grid lg:grid-cols-2 lg:pt-6">
                                <div className="mb-6 lg:my-0 text-center">
                                    <div className="w-24 h-24 mx-auto bg-white rounded-full overflow-hidden mb-4" id="contactImage"></div>
                                    <span className="text-lg font-semibold" id="contactName"></span>
                                </div>
                                <div>
                                    <div className="block text-xl font-semibold mb-4" id="rekordName"></div>
                                    <div className="flex">
                                        <div className="pt-1">
                                            <IconMapMarker w="24" h="24" />
                                        </div>
                                        <span className="ml-2 text-base font-light" id="rekordAddress">bitte PLZ eingeben</span>
                                    </div>

                                    <div className="flex items-center my-6 lg:mt-0 lg:mb-3">
                                        <IconPhone w="24" h="24" />
                                        <span className="ml-2 contact-result" id="contactPhoneNumber">bitte PLZ eingeben</span>
                                    </div>
                                    <div className="flex items-center">
                                        <IconEnvelope w="24" h="16" />
                                        <span className="ml-2 contact-result" id="contactMail">bitte PLZ eingeben</span>
                                    </div>
                                </div>
                                <div className="lg:col-span-3 mt-4">
                                    <button
                                        className="text-sm mt-8 flex items-center mx-auto opacity-40 hover:opacity-100 transition-opacity duration-300"
                                        onClick={() => {
                                            setContactType('');
                                            setPartnerExpanded(false);
                                            setSectionMainTitle(title);
                                            setResponseExpanded(true)
                                        }}
                                    >
                                        <span class="text-black font-bold">&lt;</span>&nbsp;<span>Zurück</span>
                                    </button>
                                    {zipCode !== '' && locationName !== '' &&
                                        <div className='pt-8 text-center'>
                                            <span className="text-sm">Dein Standort:<br /><strong>{locationName}</strong></span>
                                            <button
                                                className="mt-4 text-sm flex items-center mx-auto opacity-100 hover:opacity-40 transition-opacity duration-300"
                                                onClick={() => {
                                                    setPartnerExpanded(false);
                                                    setResponseExpanded(false);
                                                    setCallMeBackExpanded(false);
                                                    setSectionMainTitle(title);
                                                    setContactType('contacts')
                                                    setLocationsSelectorExpanded(true);
                                                    setZipFormExpanded(true)
                                                }}
                                            >
                                                Möchtest du einen<span class="font-bold text-rekord-orange">&nbsp;anderen Standort&nbsp;</span>auswählen?
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className={isResponseExpanded ? 'translate-x-0 transition-transform duration-300 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-y-12 xl:gap-12 py-8 lg:py-16' : 'translate-x-full transition-transform duration-300 opacity-0 overflow-hidden max-h-0'}>
                                <div className="text-center">
                                    <h4 className="text-lg lg:text-xl font-semibold mb-4">
                                        <div className="-ml-2 flex justify-center">
                                            <IconCallMeBackNew w="80" h="80" />
                                        </div>
                                        <div className="pt-4">{settings.footerNewTitleStep2Col3}</div>
                                    </h4>
                                    <p className="text-sm mb-6">{settings.footerNewTextStep2Col3}</p>
                                    <button onClick={() => {
                                        setContactType('call_me_back');
                                        (zipCode !== '' ? getSellerContacts(zipCode, 'assigned', 'call_me_back') : setZipFormExpanded(true));
                                        setResponseExpanded(false)
                                    }} className="btn btn-green text-sm">Rückruf anfordern</button>
                                </div>
                                <div className="text-center">
                                    <h4 className="text-lg lg:text-xl font-semibold mb-4">
                                        <div className="-ml-2 flex justify-center">
                                            <IconAppointment w="80" h="80" />
                                        </div>
                                        <div className="pt-4">{settings.footerNewTitleStep2Col2}</div>
                                    </h4>
                                    <p className="text-sm mb-6">{settings.footerNewTextStep2Col2}</p>
                                    <button onClick={() => {
                                        setContactType('booking');
                                        (zipCode !== '' ? getSellerContacts(zipCode, 'assigned', 'booking') : setZipFormExpanded(true));
                                        (zipCode !== '' ? setResponseExpanded(true) : setResponseExpanded(false));
                                        setSectionMainTitle(settings.footerNewTitleStep2Col2);
                                    }} className="btn btn-green text-sm inline-block">Jetzt buchen</button>
                                </div>
                                <div className="text-center">
                                    <h4 className="text-lg lg:text-xl font-semibold mb-4">
                                        <div className="-ml-2 flex justify-center">
                                            <IconAssistant w="80" h="80" />
                                        </div>
                                        <div className="pt-4">{settings.footerNewTitleStep2Col1}</div>
                                    </h4>
                                    <p className="text-sm mb-6">{settings.footerNewTextStep2Col1}</p>
                                    <button onClick={() => {
                                        setContactType('contacts');
                                        (zipCode !== '' ? getSellerContacts(zipCode, 'assigned', 'contacts') : setZipFormExpanded(true));
                                        setSectionMainTitle(settings.footerNewTitleStep2Col1);
                                        setResponseExpanded(false)
                                    }} className="btn btn-green text-sm inline-block">Zu den Kontaktdaten</button>
                                </div>
                            </div>
                        </div>
                        {
                            zipCode !== '' &&
                            locationName !== '' &&
                            !isPartnerExpanded &&
                            !isCallMeBackExpanded &&
                                <div className='pt-8 text-center'>
                                    <span className="text-sm">Dein Standort:<br /><strong>{locationName}</strong></span>
                                    <button
                                        className="mt-4 text-sm flex items-center mx-auto opacity-100 hover:opacity-40 transition-opacity duration-300"
                                        onClick={() => {
                                            setPartnerExpanded(false);
                                            setResponseExpanded(false);
                                            setCallMeBackExpanded(false);
                                            setSectionMainTitle(title);
                                            setContactType(false)
                                            setLocationsSelectorExpanded(true);
                                            setZipFormExpanded(true)
                                        }}
                                    >
                                        Möchtest du einen<span class="font-bold text-rekord-orange">&nbsp;anderen Standort&nbsp;</span>auswählen?
                                    </button>
                                </div>
                        }
                    </div>
                </section >
                : ''
            }
            {!landing ?
                <>
                    <footer className="bg-rekord-dgray text-white footer">
                        <div className="container mx-auto py-16 relative">
                            <div className="absolute right-4 -top-6 flex">
                                <a href="https://www.facebook.com/rekordfenster/" title="Folge uns auf Facebook!" target="_blank" rel="noreferrer" className="bg-white shadow p-4 hover:opacity-100 hover:bg-rekord-orange no-underline">
                                    <IconFacebook w="20" h="22" />
                                </a>
                                <a href="https://www.instagram.com/rekord_fenster_official" title="Folge uns auf Instagram!" target="_blank" rel="noreferrer" className="bg-white shadow p-4 mx-3 hover:opacity-100 hover:bg-rekord-orange">
                                    <IconInstagram w="20" h="20" />
                                </a>
                                <a href="https://www.youtube.com/channel/UCQBOczZUg3SksmeHKp9eIYQ" title="Folge uns auf YouTube!" target="_blank" rel="noreferrer" className="bg-white shadow p-4 hover:opacity-100 hover:bg-rekord-orange">
                                    <IconYouTube w="25" h="20" />
                                </a>
                            </div>
                            <FooterNav />
                            <div className="pt-8">© {new Date().getFullYear()} - Rekord Franchise GmbH</div>
                        </div>
                    </footer>
                    <BackToTop />
                </>
                : ''}

            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteStructuredData) }}
            />
        </>
    );

}
